// src/api/adminCustomerApi.ts
import axios from "axios";

const BASE_URL = "https://gg-api.nationtonation.ca/api/admin/customers";

// Admin fetch for customer overview with optional filters
export const fetchCustomerOverview = async (
  customerId: number,
  {
    page = 1,
    limit = 10,
    status = "",
    startDate = "",
    endDate = ""
  }: {
    page?: number;
    limit?: number;
    status?: string;
    startDate?: string;
    endDate?: string;
  } = {}
) => {
  const params = new URLSearchParams({
    page: String(page),
    limit: String(limit),
    ...(status ? { status } : {}),
    ...(startDate ? { startDate } : {}),
    ...(endDate ? { endDate } : {})
  });

  const response = await axios.get(`${BASE_URL}/${customerId}/overview?${params}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
  });

  return response.data;
};
